import emptyFieldValidate from "../../shared/empty.validate";
import mailValidate from "../../shared/mail.validate";
import usernameValidate from "../../shared/username.validate";

export type TErrors = {
  name: string | undefined;
  lastname: string | undefined;
  username: string | undefined;
  mail: string | undefined;
  state: string | undefined;
};

const editUser = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    name: undefined,
    lastname: undefined,
    username: undefined,
    mail: undefined,
    state: undefined,
  };

  errors.name = emptyFieldValidate(FormValues.name, "Name");

  errors.lastname = emptyFieldValidate(FormValues.lastname, "Last Name");

  errors.username = usernameValidate(FormValues.username);

  errors.mail = mailValidate(FormValues.mail);

  errors.state = emptyFieldValidate(FormValues.state, "State");

  return errors;
};

export default editUser;
